export default __webpack_public_path__ + "static/media/Ballroll_00075.5e3d5008.png";